import './LostPassword.scss';

import { passwordClient } from 'api';
import useAuth from 'common/useAuth';
import { PublicPage } from 'components/Layout';
import { useCustomTranslation } from 'helpers/translationHelper';
import React, { useCallback, useState } from 'react';

import type { LostPasswordFormValues } from './components/LostPasswordForm';
import LostPasswordForm from './components/LostPasswordForm';
import type { LostPasswordCredentials } from './models';

const LostPassword: React.FC = (): React.ReactElement => {
  const { t } = useCustomTranslation();
  const { tenantCode } = useAuth();

  const [requestSent, setRequestSent] = useState(false);

  const handleSubmit = useCallback(
    async (values: LostPasswordFormValues) => {
      const submitValues: LostPasswordCredentials = {
        tenantCode: tenantCode || values.tenantCode || '',
        username: values.username
      };

      await passwordClient.requestPasswordRecovery(submitValues);
      setRequestSent(true);
    },
    [tenantCode]
  );

  return (
    <PublicPage className="LostPassword" title={t('password.lostTitle')}>
      <div className="LostPassword_content white-box">
        <div className="LostPasswod_heading heading">{t('password.forgetPasswordHeading')}</div>

        {requestSent ? (
          <div className="LostPassword_info">{t('password.requestSentText')}</div>
        ) : (
          <LostPasswordForm onSubmit={handleSubmit} tenantCode={tenantCode} />
        )}
      </div>
    </PublicPage>
  );
};

export default LostPassword;
